import React, { Component } from 'react';

export default class Kontakt extends Component {
  
  componentDidMount() {
      try {
        window.adjustSubmenu();
      }
      catch(err) {
        console.log(err);
      }
  }
  
  render() {
    return (
      <div className="Kontakt">
          <div className="block row portfolio section bg-light" data-nested="not-nested" data-containerid="" data-containercssclass="">
          <h1>Eingeschränkte Erreichbarkeit</h1>
          <center><h2>Bis 05. Mai 2025 wegen IT-Umstellung</h2>
          <p>Liebe Kundinnen, Liebe Kunden,<br></br>
          wir haben eine interne IT-Umstellung und sind daher bis einschließlich 05.05.2025 telefonisch und per E-Mail nicht erreichbar.
          In dieser Zeit werden unsere E-Mails und Anrufe also nicht bearbeitet und nicht weitergeleitet.
          <br></br>
          In dringenden Fällen wenden Sie sich bitte an unsere Notdienstnummer.
          Diese ist unseren Wartungsvertragskunden bekannt.
          </p></center>
        </div>
        <div id="content" className="container" role="main">
          <div id="Anschrift" className="block row" data-nested="not-nested" data-containerid="" data-containercssclass="">
            <div className="col col-md-12">
              <respond-html id="html-1" description="HTML">
                <div className="section">
                  <div className="row">
                    <div className="col-md-6">
                      <b>Fa. Kurt Pailer GmbH &amp; Co.KG</b>
                      <br></br>
                      <br></br>Kinzigstraße 4
                            <br></br>75196 Remchingen- Wilferdingen
                            <br></br>Tel.: <a href="tel:+497232372506">07232 / 37 25 06</a>
                            <br></br>Fax : 07232/ 37 25 07
                            <br></br>
                      <br></br>E-Mail: <a href="mailto:info@pailer.com">info@pailer.com</a>
                      <br></br>Internet: <a href="http://pailer.com" target="_blank">www.pailer.com</a>
                      <br></br>
                      <br></br><b>Unser Büro ist an folgenden Zeiten für Sie geöffnet:</b>
                      <br></br>
                      <br></br>Montag - Freitag: 08:00 - 13:00 Uhr
                            <br></br>Donnerstag: 08:00 - 13:00 Uhr und 14:00 bis 16:00
                            <br></br>
                      <br></br>Gerne können Sie mit uns außerhalb dieser Zeiten einen Beratungstermin vereinbaren.
                            <p></p>
                      Folgend finden Sie unseren Link zum Formular <a href="https://form.jotform.com/241891684910363" target="blank">Anfrage (externe Webseite)</a><i className="fa-solid fa-up-right-from-square"></i>: 
                          <p></p>
                          <a href="https://form.jotform.com/241891684910363" target="blank">
                            <button type="button" class="btn btn-primary btn-sm">Zum Formular Anfrage</button>
                          </a>
                          <p></p>
                    </div>
                  </div>
                </div>
              </respond-html>
            </div>
          </div>
          <div id="servicezeiten" className="block row portfolio section bg-light-gray" data-nested="not-nested" data-containerid="" data-containercssclass="">
          <div className="col col-md-12">
            <div className="services" id="Telefonische Erreichbarkeit">
              <div className="">
                <div className="row text-center">
                  <div className="col-md-6">
                    <span className="fa-stack fa-4x">
                      <i className="fa fa-circle fa-stack-2x text-primary"></i>
                      <i className="fa fa-mobile fa-stack-1x fa-inverse"></i>
                    </span>
                    <h4 className="service-heading">Telefonzeiten / Anfragen</h4>
                    <p className="text-muted">Wir haben unsere Telefonzeiten angepasst. 
                    <br></br><br></br>
                    Sie erreichen uns täglich: 08:00-13:00 Uhr und zusätzlich donnerstags 14:00-16:00 Uhr.
                    <br></br><br></br>
                    Gerne können Sie uns außerhalb dieser Zeiten eine e-mail schreiben, wir rufen Sie zurück. Selbstverständlich sind wir für unsere Bestandskunden in Notfällen auch außerhalb unserer Bürozeiten über unsere Notdienstnummer erreichbar.  
                    <br></br><br></br>                    
                    <a href="mailto:info@pailer.com">info@pailer.com</a> | <a href="tel:+497232372506">07232 / 37 25 06</a>
                    <br></br><br></br>
                      Folgend finden Sie unseren Link zum Formular <a href="https://form.jotform.com/241891684910363" target="blank">Anfrage (externe Webseite)</a><i className="fa-solid fa-up-right-from-square"></i>: 
                          <p></p>
                          <a href="https://form.jotform.com/241891684910363" target="blank">
                            <button type="button" class="btn btn-primary btn-sm">Zum Formular Anfrage</button>
                          </a>
                          <p></p>
                    Vielen Dank für Ihr Vertrauen
                    <br></br>
                    Ihr Team der Firma Kurt Pailer GmbH & Co. KG
                    </p>
                  </div>
                  <div className="col-md-6">
                    <span className="fa-stack fa-4x">
                      <i className="fa fa-circle fa-stack-2x text-primary"></i>
                      <i className="fa fa-wrench fa-stack-1x fa-inverse"></i>
                    </span>
                    <h4 className="service-heading">Notdienst</h4>
                    <p className="text-muted">Sie haben am Wochenende oder am Feiertag eine akute Heizungsstörung, kein Warmwasser und Ihre Räume sind kalt?
                    <br></br><br></br>
                    Sie haben einen Wasserrohrbruch?<br></br>
                    Für unsere Bestandskunden rücken unsere Techniker auch außerhalb der üblichen Arbeitszeiten, am Wochenende oder an Feiertagen aus.
                    <br></br><br></br>
                    Der Feierabend und auch die Wochenenden sind für unsere Techniker als Erholungsphasen sehr wichtig.
                    <br></br><br></br>
                    Bitte prüfen Sie daher im Vorfeld, ob es sich um einen tatsächlichen Notfall handelt oder ob es bis zum nächsten Tag warten kann.
                    <br></br><br></br>
                    Vielen Dank für Ihr Vertrauen
                    <br></br>
                    Ihr Team der Firma Kurt Pailer GmbH & Co. KG</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/kontakt/Kontakt.js